import { combineReducers } from 'redux';

import terms from 'core/modules/Referral/components/Terms/reducers';

export default combineReducers({
  terms,
});
